import { useSelector } from "react-redux";
import { CheckPermissions } from "../../../../logic/Admin/Permissions/CheckPermission/CheckPermissions";
import { selectUserData } from "../../../../features/userSlice";
import Page404 from "../../../../components/Page404/Page403";
// BrandConfigurationOverview now lives under the Brands module folder — moved,
// not duplicated. This screen/route/permission-check is otherwise unchanged.
import BrandConfigurationOverview from "../../../../components/Partners/DataIntegrations/Brands/BrandConfigurationOverview/BrandConfigurationOverview"
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { resetBrandConfigurationReportState } from "../../../../features/brandConfigurationReportSlice";

const BrandConfigurationOverviewScreen = () => {
  const userData = useSelector(selectUserData);
  const dispatch = useDispatch();
  const hasBrandConfigurationsReportPermission = CheckPermissions(
    userData?.data?.products?.partners,
    "data_intregrations",
    "view_brand_configurations"
  );

  //--Cleanup on unmount
  useEffect(() => {
    return () => {
      dispatch(resetBrandConfigurationReportState());
    };
  }, [dispatch]);

  return (
    <>
      {hasBrandConfigurationsReportPermission ? (
        <BrandConfigurationOverview />
      ) : (
        <Page404 />
      )}
    </>
  );
};

export default BrandConfigurationOverviewScreen;
